import { Routes } from '@angular/router';
import { isAuthenticatedGuard } from './core/auth/is-authenticated.guard';
import { UnauthenticatedComponent } from './core/auth/unauthenticated.component';

export const routes: Routes = [
  {
    path: 'unauthenticated',
    component: UnauthenticatedComponent
  },
  {
    path: '',
    loadComponent: () => import('./modules/start/start.component').then(m => m.StartComponent),
    canActivate: [isAuthenticatedGuard]
  },
  {
    path: "**",
    redirectTo: '',
  }
];
